export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11223.b39a263c.jpg";